module.exports = __webpack_public_path__ + "img/tc5.2983b354.png";